
(function () {
  function injectLooxStyles() {
    const looxWidget = document.querySelector('.loox-widget');

    if (!looxWidget) return false;

    // Shadow root might not be ready yet
    const shadow = looxWidget.shadowRoot;
    if (!shadow) return false;

    if (shadow.querySelector('#custom-loox-style')) {
      return true;
    }

    const style = document.createElement('style');
    style.id = 'custom-loox-style';

    style.textContent = `
      .review-text {
        font-size: 16px !important;
        line-height: 19px !important;
        letter-spacing: .065em !important;
      }

      @media (max-width: 720px) {
        .review-text {
          -webkit-line-clamp: 4 !important;
          max-height: 76px !important;
        }
      }
    `;

    shadow.appendChild(style);
    return true;
  }

  function startObserver() {
    const observer = new MutationObserver(() => {
      injectLooxStyles();
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }

  // Keep trying until widget is ready
  const interval = setInterval(() => {
    if (injectLooxStyles()) {
      clearInterval(interval);
    }
  }, 500);

  startObserver();
})();

document.addEventListener('DOMContentLoaded', function () {
          const container = document.querySelector('.both_combined_calculator');
          if (!container) return;

          function checkRoomvoButton() {
            const roomvoBtn = container.querySelector('button.roomvo-stimr');

            if (!roomvoBtn) {
              container.classList.add('Only_size_calculator');
              
            } else {
              container.classList.remove('Only_size_calculator');
              

              // Once button is found, we can disconnect observer to prevent repeated calls
              if (observer) observer.disconnect();
            }
          }

          // Initial check
          checkRoomvoButton();

          // Observe DOM changes (Roomvo button may load dynamically)
          const observer = new MutationObserver((mutations) => {
            // Only check if a new node is added
            for (let mutation of mutations) {
              if (mutation.addedNodes.length > 0) {
                checkRoomvoButton();
                break; // stop after first relevant change
              }
            }
          });

          observer.observe(container, {
            childList: true,
            subtree: true,
          });
        });

         const observer = new MutationObserver(() => {
          const buttons = document.querySelectorAll("button.roomvo-stimr");
          const targetDiv = document.querySelector(".both_combined_calculator");
          const wallpaperSizeCalculator = targetDiv?.querySelector(".wallpaper-size-calculator");

          

          buttons.forEach(btn => {

            // Prevent duplicate execution
            if (btn.classList.contains("processed")) return;
            btn.classList.add("processed");

            // Insert the button above the wallpaper-size-calculator element
            if (wallpaperSizeCalculator) {
              wallpaperSizeCalculator.parentNode.insertBefore(btn, wallpaperSizeCalculator);
            }

            // Add SVG only once
            if (!btn.querySelector("svg")) {
              const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
              svg.setAttribute("width", "19");
              svg.setAttribute("height", "17");
              svg.setAttribute("viewBox", "0 0 19 17");
              svg.style.marginRight = "5px";
              svg.style.marginTop = "3px";

              svg.innerHTML = `
                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.67383 8.75C5.67383 7.75544 6.06892 6.80161 6.77218 6.09835C7.47544 5.39509 8.42927 5 9.42383 5C10.4184 5 11.3722 5.39509 12.0755 6.09835C12.7787 6.80161 13.1738 7.75544 13.1738 8.75C13.1738 9.74456 12.7787 10.6984 12.0755 11.4017C11.3722 12.1049 10.4184 12.5 9.42383 12.5C8.42927 12.5 7.47544 12.1049 6.77218 11.4017C6.06892 10.6984 5.67383 9.74456 5.67383 8.75ZM9.42383 6.5C8.82709 6.5 8.25479 6.73705 7.83284 7.15901C7.41088 7.58097 7.17383 8.15326 7.17383 8.75C7.17383 9.34674 7.41088 9.91903 7.83284 10.341C8.25479 10.7629 8.82709 11 9.42383 11C10.0206 11 10.5929 10.7629 11.0148 10.341C11.4368 9.91903 11.6738 9.34674 11.6738 8.75C11.6738 8.15326 11.4368 7.58097 11.0148 7.15901C10.5929 6.73705 10.0206 6.5 9.42383 6.5Z" fill="white"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M8.03983 1.5C7.79129 1.49974 7.54515 1.5485 7.31548 1.64348C7.08581 1.73847 6.87714 1.87783 6.7014 2.05357C6.52565 2.22931 6.3863 2.43798 6.29131 2.66765C6.19632 2.89732 6.14756 3.14347 6.14783 3.392C6.14766 3.71318 6.02674 4.02256 5.80908 4.25875C5.59142 4.49493 5.29293 4.64065 4.97283 4.667L2.74283 4.847C2.52957 4.86417 2.32788 4.95102 2.16886 5.09414C2.00983 5.23727 1.90229 5.42872 1.86283 5.639C1.41405 8.00888 1.38089 10.4388 1.76483 12.82L1.86183 13.424C1.95383 13.994 2.42283 14.429 2.99883 14.476L4.94183 14.634C7.92492 14.8761 10.9227 14.8761 13.9058 14.634L15.8478 14.476C16.1279 14.4534 16.3923 14.3374 16.5986 14.1466C16.8049 13.9559 16.9413 13.7014 16.9858 13.424L17.0828 12.82C17.4664 10.4387 17.4329 8.00882 16.9838 5.639C16.9442 5.42891 16.8365 5.23768 16.6775 5.09475C16.5185 4.95182 16.3169 4.86512 16.1038 4.848L13.8748 4.667C13.5547 4.64065 13.2562 4.49493 13.0386 4.25875C12.8209 4.02256 12.7 3.71318 12.6998 3.392C12.7001 3.14347 12.6513 2.89732 12.5563 2.66765C12.4614 2.43798 12.322 2.22931 12.1463 2.05357C11.9705 1.87783 11.7618 1.73847 11.5322 1.64348C11.3025 1.5485 11.0564 1.49974 10.8078 1.5H8.03983ZM4.65383 3.188C4.70605 2.32533 5.08549 1.51509 5.71473 0.922646C6.34397 0.330201 7.17557 0.000204142 8.03983 0H10.8078C12.6128 0 14.0878 1.41 14.1938 3.188L16.2258 3.353C16.7664 3.39664 17.2777 3.6167 17.681 3.97933C18.0843 4.34196 18.3572 4.82707 18.4578 5.36C18.9388 7.9 18.9748 10.505 18.5638 13.058L18.4668 13.663C18.3688 14.2716 18.0696 14.8298 17.6169 15.2482C17.1642 15.6666 16.5842 15.9211 15.9698 15.971L14.0278 16.129C10.9635 16.3773 7.88414 16.3773 4.81983 16.129L2.87783 15.971C2.26341 15.9211 1.68347 15.6666 1.23079 15.2482C0.778101 14.8298 0.478824 14.2716 0.380828 13.663L0.283828 13.058C-0.127391 10.5053 -0.0915235 7.90045 0.389828 5.36C0.490601 4.82714 0.7636 4.34213 1.16685 3.97952C1.57011 3.61692 2.08129 3.3968 2.62183 3.353L4.65383 3.188Z" fill="white"/>
              `;

              btn.insertBefore(svg, btn.firstChild);
            }
          });
          observer.disconnect(); // stop observing once done
        });
        observer.observe(document.body, {
          childList: true,
          subtree: true
        });

         document.addEventListener("DOMContentLoaded", function () {
        const description = document.querySelector('.product__description');
        const accordion = document.querySelector('.product__accordion');

        if (!description || !accordion) return;

        const innerTag = description.querySelector('*');

        if (!innerTag) return;

        if (innerTag.contains(accordion)) return;
      if (innerTag.contains(accordion)) {
        innerTag.appendChild(accordion);
      };
      });

       document.addEventListener("DOMContentLoaded", function() {
          // Function to hide all myregistry elements
          function hideMyRegistry() {
              var elements = document.getElementsByClassName("myregistry");
              for (var i = 0; i < elements.length; i++) {
                  elements[i].style.display = "none";
              }
          }

          // Initial hide
          hideMyRegistry();

          // MutationObserver to watch for dynamically added elements
          var observer = new MutationObserver(function(mutations) {
              mutations.forEach(function(mutation) {
                  hideMyRegistry(); // hide new elements whenever DOM changes
              });
          });

          // Observe body for any child changes
          observer.observe(document.body, { childList: true, subtree: true });
      });

       (function () {
        const interval = setInterval(() => {
            const embed = document.querySelector('shopify-forms-embed');

            if (embed && embed.shadowRoot) {
                clearInterval(interval);

                const root = embed.shadowRoot;

                /* ----------------------- INJECT CSS ----------------------- */
                  const css = `
                    /* Common field styling */
                    
                      #app-embed h2 {
                          font-family: 'Inria Sans', sans-serif !important;
                      }
                      ._radioField_nw6va_1 {
                      display: grid;
                      grid-template-columns: 1em minmax(0px, 1fr);
                      word-break: break-word;
                      gap: 30px;
                      align-items: center;
                      font-size: 1rem;
                  }
                    
                      ._inline_1q1d2_47 ._formContainer_1q1d2_30{
                        max-width: 450px;
                        margin: 0 auto;
                      }
                      ._inline_1q1d2_47 ._formContainer_1q1d2_30 {
                        padding-bottom: 30px;
                      }
                      ._formFileInput_ehvsf_1 {
                        margin-top: 20px !important;
                      }
                      ._checkboxField_1hja3_3 {
                          display: grid;
                          grid-template-columns: 1em minmax(0px, 1fr);
                          gap: 8px;
                          align-items: center;
                          font-size: 1em;
                          word-break: break-word;
                        }
                        ._checkboxFieldSet_1hja3_3 {
                          border: medium;
                          padding: 0px;
                        }
                        ._formFileInputField_ehvsf_5 {
                            background-color: #fff;
                            color: #202020;
                            border: 1px dashed #ccc;
                            border-radius: 5px;
                            display: flex;
                            padding: 20px 0px;
                            cursor: pointer;
                            justify-content: center;
                            margin-top: 8px;
                            width: 100%;
                        }
                        ._radioFieldSet_nw6va_1 {
                            border: none;
                            padding: 0px;
                        }
                        ._horizontalLayout_nw6va_12 {
                        display: grid;
                        grid-template-columns: 1fr 1fr 1fr;
                        gap: 10px;
                        }
                        button._formSubmitButton_cit2d_96 {
                            padding: 15px;
                            color: #fff;
                        }
                      ._formFileInput_ehvsf_1 p._textBody_2aowh_10{
                      
                          font-weight: 400 !important;
                          line-height: 13px !important;
                          color: #595959 !important;
                          margin: 0 0 10px !important;
                      }
                    #app-embed p._label_12thd_10._textBody_2aowh_10 {
                        font-family: 'Inria Sans', sans-serif !important;
                    }
                    #app-embed label {
                        font-family: 'Inria Sans', sans-serif !important;
                        font-weight: 400;
                    } 
                    #app-embed ._formPhoneInputContainer_piv1u_6 {
                      margin-bottom: 20px !important;
                    }
                    #app-embed ._formFieldContainer_1mxsl_5 {
                        display: flex !important;
                        flex-direction: column !important;
                        margin-bottom: 20px !important;
                        position: relative;
                    }
                    #app-embed ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 {
                        margin-bottom: 0 !important;
                    }
                    #app-embed ._formInputField_nag3b_7,
                    #app-embed ._formPhoneInputField_piv1u_17,
                    #app-embed ._textArea_17mgw_1 {
                        margin-top: 0 !important;
                    }

                    #app-embed ._formFieldContainer_1mxsl_5:has(textarea)::before {
                        display: none !important;
                        content: none !important;
                    }

                      #app-embed ._formFieldContainer_1mxsl_5 label {
                          top: 41px !important;
                          order: -1 !important;
                          font-weight: 400 !important;
                          font-size: 14px !important;
                          transition: opacity 0.2s;
                          color: #121212bf;
                          margin: 0px !important;
                          position: absolute;
                          left: 15px;
                          line-height: 1;
                      }
                      #app-embed ._formFieldContainer_1mxsl_5 textarea:focus+label,
                      #app-embed ._formFieldContainer_1mxsl_5 input:focus+label {
                        transform: translateY(-5px) scale(0.85);
                        transform-origin: left top;
                      }
                      ._selectToggleText_12thd_25 {
                          width: calc(100% - 20px);
                          height: 100%;
                          display: flex;
                          align-items: center;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                      }
                    #app-embed form._formFieldset_cit2d_82 {
                        gap: 0px !important;
                    }
                    ._gridItemContent_1q1d2_257 {
                      padding: 30px 0;
                    }
                    #app-embed input:focus-visible,
                    #app-embed textarea:focus-visible,
                    #app-embed ._selectToggle_12thd_25:focus-visible {
                        box-shadow: 0 0 0 1px #000000 !important;
                    }
                    #app-embed ._selectToggle_12thd_25:focus-visible {
                        background: black;
                    }
                    #app-embed ._selectToggle_12thd_25 {
                      border-radius: 0px !important;
                      border: 1px solid #444;
                      box-shadow: none;
                      padding: 13.5px 15px 18.5px;
                      line-height: 1;
                      font-family: 'Inria Sans', sans-serif !important;
                      font-size: 14px;
                      margin: 0;
                      outline: none;
                  }
                    #app-embed input:focus-visible:hover {
                        border: 1px solid #000 !important;
                    }
                    #app-embed input, #app-embed ._formFieldContainer_1mxsl_5 textarea {
                      border-radius: 0px !important;
                      border: 1px solid #444;
                      box-shadow: none;
                      
                      line-height: 1;
                      font-family: 'Inria Sans', sans-serif !important;
                      font-size: 14px;
                      margin: 0;
                      outline: none;
                    }
                    #app-embed ._optionListItem_12thd_102 > div:focus {
                        background-color: #000000 !important;
                        outline: 0px solid #000000 !important;
                        color: #ffffff !important;
                    }
                    #app-embed ._selectToggle_12thd_25 img{
                        width: 27px;
                        height: 20px;
                    }
                    #app-embed ._optionListItem_12thd_102:hover {
                        background-color: #000000 !important;
                        outline: 0px solid #000000 !important;
                        color: #fff !important;
                        border-radius: 0px !important;
                    }
                    #app-embed button._formSubmitButton_cit2d_96 {
                        margin-top: 1rem !important;
                        background: #7ca19d;
                        border-radius: 0px;
                        width: 100%;
                        font-weight: 400;
                        cursor: pointer;
                        border: none;
                        z-index: 1;
                        position: relative;
                    }      
                    #app-embed button._formSubmitButton_cit2d_96:hover {
                        filter: opacity(80%);
                    }                         
                    /* Phone + country horizontal layout */
                    #app-embed ._formPhoneInputContainer_piv1u_6 {
                        display: flex !important;
                        gap: 10px;
                        
                    }
                    #app-embed ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 {
                        flex: 1;
                    }
                    #app-embed ._formPhoneInputContainer_piv1u_6 .phone-country-selector {
                        flex-shrink: 0;
                    }
                    #app-embed ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5 label {
                        top: 14px !important;
                        order: -1 !important;
                        margin-bottom: 6px !important;
                        font-weight: 500 !important;
                        font-size: 14px !important;
                        line-height: 1;
                        transition: opacity 0.2s;
                        transform: translateY(-5px) scale(0.85);
                        transform-origin: left top;
                    }
                    /* H2 styling for normal fields */
                    #app-embed h2.form-field-label {
                        font-size: 16px;
                        font-weight: 400;
                        line-height: 13px;
                        color: #595959;
                        margin: 0 0 10px;
                    }
                    #app-embed p._label_12thd_10._textBody_2aowh_10 {
                      font-size: 16px;
                      font-weight: 400;
                      line-height: 13px;
                      color: #595959;
                  }
                  #app-embed legend._textBody_2aowh_10._radioLegend_nw6va_18 {
                      font-size: 16px;
                      font-weight: 400;
                      line-height: 13px;
                      color: #595959;
                      margin-top: 0px !important;
                      padding-top: 8px !important;
                      padding-bottom: 15px !important;
                  }
                  ._textBody_2aowh_10 p strong {
                    font-family: 'Inria Sans', sans-serif !important;
                    font-weight: 400;
                  }
                  #app-embed label span._textBody_2aowh_10 {
                    font-family: 'Inria Sans', sans-serif !important;
                  }
                  ._selectToggle_12thd_25 {
                      max-height: 48px !important;
                      display: flex;
                      background: transparent;
                      width: 100%;
                  }
                      #app-embed ._formFieldContainer_1mxsl_5 output._formError_1mxsl_21 {
                        padding-top: 10px !important;
                    }
                        
                    ._selectContainer_12thd_6 {
                        margin-bottom: 20px !important;
                    }
                    #app-embed ._selectContainer_12thd_6:focus-visible {
                        box-shadow: 0 0 0 1px #000000 !important;
                    }
                    #app-embed ._formFieldContainer_1mxsl_5 textarea {
                        border-radius: 0px !important;
                    }
                    /* Hide H2 above phone number */
                    #app-embed ._formPhoneInputContainer_piv1u_6 h2.form-field-label {
                        display: none !important;
                    }
                    #app-embed ._arrowDownIcon_12thd_19 {
                        margin: 9px !important;
                        pointer-events: none !important;
                        color: var(--form-text-color) !important;
                    }
                    #app-embed ._optionListItemSelected_12thd_112 {
                        box-shadow: none !important;
                    }
                    #app-embed ._optionListItemSelected_12thd_112 > div,
                    #app-embed ._optionListItem_12thd_102 > div:focus,
                    #app-embed ._optionListItem_12thd_102:hover {
                        background-color: #000000 !important;
                        outline: 1px solid #000000 !important;
                        color: #fff !important;
                        border-radius: 0px !important;
                    }
                    ._formPhoneInputContainer_piv1u_6 ._selectContainer_12thd_6 {
                        margin-bottom: 0px !important;
                    }
                  #app-embed ._optionListItem_12thd_102 > div {
                      border-radius: 0px !important;
                      color: #595959;
                  }
                  #app-embed ._showDownwards_12thd_72 {
                    z-index: 2;
                    top: 100%;
                    left: -1px !important;
                    margin-top: 1px !important;
                    width: 444px !important;
                    height: 100% !important;
                    min-height: 182px !important;
                    border-radius: 0px !important;
                    border: 1px solid #000 !important;
                    border-top: 0px !important;
                    position: absolute;
                  }
                  #app-embed ._optionList_12thd_86 {
                    margin-bottom: 5px;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 19px;
                    letter-spacing: 0;
                    text-align: left;
                    padding: 9px 12px 8px;
                    overflow-y: auto;
                  }
                  #app-embed ._optionList_12thd_86>div>div {
                    padding: 9px 12px 8px;
                    margin-bottom: 5px;
                    background: transparent;
                  }
                `;

                const style = document.createElement('style');
                style.textContent = css;
                root.appendChild(style);

                /* ------------------- ADD PHONE H2 -------------------- */
                const phoneContainer = root.querySelector('._formPhoneInputContainer_piv1u_6');

                if (phoneContainer && !phoneContainer.previousElementSibling?.classList.contains('form-field-label')) {
                    const h2 = document.createElement('h2');
                    h2.textContent = 'Phone Number';
                    h2.className = 'form-field-label';
                    phoneContainer.parentNode.insertBefore(h2, phoneContainer);
                }

                /* ------------------- ADD H2 FOR OTHER FIELDS -------------------- */
                const fields = root.querySelectorAll('._formFieldContainer_1mxsl_5:not(._formPhoneInputField_piv1u_17)');

                fields.forEach(field => {
                    const label = field.querySelector('label');
                    const input = field.querySelector('input, textarea');

                    if (label && input && !field.querySelector('h2.form-field-label')) {
                        const h2 = document.createElement('h2');
                        h2.textContent = label.textContent.trim();
                        h2.className = 'form-field-label';
                        field.insertBefore(h2, input);

                        const toggleLabel = () => {
                            label.style.opacity = '1';
                        };

                        input.addEventListener('input', toggleLabel);
                        input.addEventListener('focus', toggleLabel);
                        input.addEventListener('blur', toggleLabel);

                        toggleLabel();
                    }
                });

                /* ================= ERROR FIX (IMPORTANT PART) ================= */

                function moveErrorsInsideField() {
                    const errors = root.querySelectorAll('output._formError_1mxsl_21');

                    errors.forEach(error => {
                        const fieldContainer = error.previousElementSibling;

                        if (
                            fieldContainer &&
                            fieldContainer.classList.contains('_formFieldContainer_1mxsl_5') &&
                            !fieldContainer.contains(error)
                        ) {
                            fieldContainer.appendChild(error);
                        }
                    });
                }

                /* Shopify errors dynamic hote hain → observe karna zaroori */
                const observer = new MutationObserver(() => {
                    moveErrorsInsideField();
                });

                observer.observe(root, {
                    childList: true,
                    subtree: true
                });

                /* ============================================================= */

            }
        }, 200);
    })();

      (function () {
            const observer = new MutationObserver(() => {
                const calculatorDiv = document.querySelector('.both_combined_calculator');
                const openPopupDiv = document.querySelector('.openPopup');

                if (calculatorDiv && openPopupDiv) {
                    calculatorDiv.insertAdjacentElement('afterend', openPopupDiv);
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        })();
        (function () {
            const observer = new MutationObserver(() => {
                const calculatorDiv = document.querySelector('.both_combined_calculator');
                const openPopupDiv = document.querySelector('.sample_button');

                if (calculatorDiv && openPopupDiv) {
                    calculatorDiv.insertAdjacentElement('afterend', openPopupDiv);
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        })();